'use strict';

module.exports = 0;



//////////////////
// WEBPACK FOOTER
// /var/www/build-lk-1/~/shortid/lib/util/cluster-worker-id-browser.js
// module id = 1808
// module chunks = 0